<template>
    <div>
        <highcharts :Highcharts="Highcharts" :options="options" ref="highchart"></highcharts>
    </div>
</template>

<style lang="scss">
    body .highcharts-subtitle {
        font-size: 14px !important;
    }
    body .highcharts-credits {
        font-size: 14px !important;
        cursor: default !important;
        color: $black !important;
        fill: $black !important;
    }
    body .highcharts-contextmenu hr {
        margin: 10px;
    }
</style>

<script>
    import {Chart} from 'highcharts-vue';
    import Highcharts from 'highcharts';
    import loadExporting from 'highcharts/modules/exporting';
    import loadExportingOffline from 'highcharts/modules/offline-exporting';

    loadExporting(Highcharts);
    loadExportingOffline(Highcharts);

    export default {
        components: {
            highcharts: Chart,
        },

        props: {
            name: {type: String, default: ''},
            categories: {type: Array, default: function() {
                return []; 
            }},
            yLabel: {type: String, default: ''},
            data: {type: Array, default: function() {
                return []; 
            }},
            chart_type: {type: String, default: 'bar'}, // column, line, spline, bar
            subtitle: {type: String, default: ''},
            footer: {type: String, default: ''},
            height: {type: Number, default: 600},
            width: {type: Number, default: null},
            allow_decimals: {type: Boolean, default: false},
            download_csv: {type: Boolean, default: false},
        },

        data() {
            return {
                Highcharts: Highcharts,
                options: {
                    chart: {
                        type: this.chart_type,
                        height: this.chart_type == 'bar' ? (200 + this.categories.length * 40) : this.height,
                        width: this.width,
                    },
                    legend: {
                        enabled: false,
                    },
                    title: {
                        text: this.name,
                    },
                    subtitle: {
                        text: this.subtitle,
                    },
                    xAxis: {
                        categories: this.categories,
                    },
                    yAxis: {
                        allowDecimals: this.allow_decimals,
                        title: {
                            text: this.yLabel,
                        },
                    },
                    credits: {
                        enabled: true,
                        href: '',
                        text: this.footer,
                    },
                    series: [
                        {
                            name: this.yLabel,
                            data: this.data,
                            color: "#990f26",
                        },
                    ],
                    tooltip: {
                        borderWidth: 0,
                        style: {
                            padding: 0,
                        },
                        useHTML: true,
                        formatter: function() {
                            let name = this.series.chart.options.chart.type === 'pie' ? this.series.chart.axes[0].categories[this.point.index] : this.key;
                            return '<table><tr><td>' + name +':</td><td>' + this.y + '</td></tr></table>';
                        },
                    },
                    exporting: {
                        enabled: true,
                        buttons: {
                            contextButton: {
                                enabled: true,
                                menuItems: [
                                    'viewFullscreen',
                                    'printChart',
                                    'separator',
                                    'downloadPNG',
                                    'downloadJPEG',
                                    'downloadSVG',
                                ],
                            },
                        },
                        chartOptions: {
                            plotOptions: {
                                series: {
                                    dataLabels: {
                                        enabled: true,
                                    },
                                },
                            },
                        },
                        fallbackToExportServer: false,
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    let sliceName = this.series.chart.axes[0].categories[this.point.index];
                                    return `<b>${sliceName}</b>: ${this.point.y}`;
                                },
                            },
                        },
                    },
                },
            };
        },

        beforeMount() {
            if (this.download_csv && this.options.exporting.buttons.contextButton.menuItems) {
                this.options.exporting.buttons.contextButton.menuItems.push({
                    text: 'Download Excel table',
                    onclick: () => {
                        this.$emit('download-csv');
                    },
                });
            }
        },
    };
</script>